import { MsalRoleContext } from '@ab-inbev/sam-auth';
import { FeatureFlagNames, useFeatureFlags } from '@ab-inbev/sam-feature-flags';
import { useContext } from 'react';

export const useIsCardVisible = ({ flag, roles }: { flag?: FeatureFlagNames; roles: string[] }) => {
  const userRoles = useContext(MsalRoleContext);

  const isEnabled = useFeatureFlags(flag) || flag === undefined;
  const hasRole = roles.some((role) => userRoles.includes(role));

  return isEnabled && hasRole;
};
